import React, { useState, useEffect } from "react";
import { makeStyles, useTheme, styled } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import {
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  Radio,
  FormLabel,
  RadioGroup,
  MenuItem,
  Paper,
  CardHeader,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import { useQuery, useMutation, useQueryClient } from "react-query";
import * as api from "../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";

//get DispensingLanguage
const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const lan = localStorage.getItem('LangCode');
const FacilityId = localStorage.getItem('FacilityId');
const menukey = "standing-board-entry";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          className="float-right"
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const DisapprovedProductsModal = ({ handleClose, open, addProductDisapproved, ...props }) => {

 // console.log("dddddddddddddddddddddddddd", props.ContractNo);
  let tblRef = null;
  
  let params = {
    action: 'getProducts',
    menukey: menukey,
    ContractNo: props.ContractNo,
    FacilityId: FacilityId,
    page_limit: JSON.stringify(100),
    page_number: JSON.stringify(0 + 1),
    search_key: "",
  };

  const { isLoading, error, isError, data, refetch } = useQuery(
    [params],
    api.getStandingBoardEntryItemsList
  );
  const [selectedProducts, setselectedProducts] = useState([]);

  const ProductColumns = [
    { title: "id", field: "ItemNo", visible: false },
    { title: "ItemNo", field: "ItemNo", visible: false },
    { title: "Generic Name", field: "GenericName", visible: false },
    { title: DispensingLanguage[lan][menukey]['Sl#'],  formatter: "rownum", width:50, hozAlign: "center" , headerHozAlign:"center", headerSort:false},
    { title: DispensingLanguage[lan][menukey]['Sup Inv'], field: "SupRef", width: 80, headerFilter:true },
    { title: DispensingLanguage[lan][menukey]['Sup Date'], field: "SupDate", width: 80, headerFilter:true },
    { title: DispensingLanguage[lan][menukey]['Received Date'], field: "pReceiveDate", width: 80, headerFilter:true },
    { title: DispensingLanguage[lan][menukey]['Item Code'], field: "ItemCode", width: 80, headerFilter:true },
    { title: DispensingLanguage[lan][menukey]['Item Name'], field: "ItemName", headerFilter:true  },
    { title: DispensingLanguage[lan][menukey]['Provisional Received Qty'], hozAlign: "right", headerHozAlign: "right",  field: "Quantity", width: 100},
    { title: DispensingLanguage[lan][menukey]['Lot No'], field: "BatchNo", width: 80},
    { title: DispensingLanguage[lan][menukey]['Mfg. Date'], field: "MfgDate", width: 80},
    { title: DispensingLanguage[lan][menukey]['Exp Date'], field: "ExpiryDate", width: 80},
    { title: "ItemSl", field: "ItemSl", width: 80, visible: false},
    { title: "SupCode", field: "SupCode", width: 80, visible: false},
    // { title: DispensingLanguage[lan][menukey]['Product Price'], field: "UnitPrice", width: 80, hozAlign: "right", headerHozAlign:"right"  },
  ];

    let selected = [];
    let rows = [];

    let autoId = Date.now(); // 0;

    //console.log("ManyTableData========= Disapproved",props.ManyTableData);

     props.ManyTableData.forEach((rowData, i) => {
          let newRow = {};
          newRow.SupCode = null;
          newRow.SupRef = rowData.SupRef;
          newRow.SupDate = null;
          newRow.ItemCode = rowData.ItemCode;
          newRow.ItemName = null;
          newRow.ContractQty = null;
          newRow.Quantity = null;
          newRow.PRQuantity = null;
          newRow.RemQty = null;
          newRow.UnitName = null;
          newRow.ContractName = null;
          newRow.BatchNo = rowData.BatchNo;
          newRow.MfgDate = rowData.MfgDate;
          newRow.ExpiryDate = rowData.ExpiryDate;
          newRow.ItemSl = rowData.ItemSl;
          newRow.pReceiveDate = null;

          rows.push(newRow); 

    }); 

    //console.log("ManyTableMergeData=========",props.ManyTableMergeData);
    
   props.ManyTableMergeData.forEach((rowData, i) => {
      let newRow = {};
      newRow.SupCode = null;
      newRow.SupRef = rowData.SupRef;
      newRow.SupDate = null;
      newRow.ItemCode = rowData.ItemCode;
      newRow.ItemName = null;
      newRow.ContractQty = null;
      newRow.Quantity = null;
      newRow.PRQuantity = null;
      newRow.RemQty = null;
      newRow.UnitName = null;
      newRow.ContractName = null;
      newRow.BatchNo = rowData.BatchNo;
      newRow.MfgDate = rowData.MfgDate;
      newRow.ExpiryDate = rowData.ExpiryDate;
      newRow.ItemSl = rowData.ItemSl;
      newRow.pReceiveDate = null;

      rows.push(newRow); 

}); 


    let filteredProductList = [];
    if (data){
        const productListvalues = Object.values(data);
        //filteredProductList = productListvalues.filter(o1 => !rows.some(o2 => o1.ItemCode === o2.ItemCode));
        filteredProductList = productListvalues.filter(o1 => !rows.some(o2 => (o1.ItemCode === o2.ItemCode) && (o1.BatchNo === o2.BatchNo) && (o1.MfgDate === o2.MfgDate) && (o1.ExpiryDate === o2.ExpiryDate) && (o1.ItemSl === o2.ItemSl)));
    }else{
        filteredProductList = [];
    }
       
    const ProdustDataItems = filteredProductList?.map((item, index) => { 
      return item;
    });

  const [btnDisable, setbtnDisable] = useState(false);

  const SaveSelectedProducts = () => {
    if(tblRef.table.getSelectedData().length>0)
    //console.log(tblRef.table.getSelectedData());
    setbtnDisable(true);
    setselectedProducts(tblRef.table.getSelectedData());
    setTimeout(() => setbtnDisable(false), 500);
    
  };

  useEffect(() => { 
    if (tblRef == null) return;
    addProductDisapproved(selectedProducts);

}, [selectedProducts]); 


  return (
    <div>
      <BootstrapDialog
        onClose={() => handleClose('DisapprovedProducts')}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth="md"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => handleClose('DisapprovedProducts')}
        >
        {DispensingLanguage[lan][menukey]['Item List']} 
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <ReactTabulator
            ref={(r) => (tblRef = r)}
            options={{
              selectableRangeMode: 'click',
             }}
            selectable={true}
            columns={ProductColumns}
            data={ProdustDataItems}
            height="300px"
            layout={"fitColumns"}

          />
        </DialogContent>
        <DialogActions>
          <Button
            disabled={btnDisable}
            className="mr-2 float-left"
            variant="contained"
            color="primary"
            onClick={SaveSelectedProducts}
          >
           {DispensingLanguage[lan][menukey]['Add']}  
          </Button>
          <Button
            autoFocus
            className="float-left"
            variant="contained" 
            onClick={() => handleClose('DisapprovedProducts')}
          >
            {DispensingLanguage[lan][menukey]['Cancel']}   
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default DisapprovedProductsModal;
